(function () {
  
  const buttons = document.querySelectorAll('.js-accordion');

  buttons.forEach(function(button) {
    const container = button.nextElementSibling;
    const close = container.querySelector('.js-accordion-close');

    button.addEventListener('click', toggle);
    if(close)close.addEventListener('click', toggle);
    function toggle() {
      const outerHeight = container.clientHeight;
      const innerHeight = container.children[0].clientHeight;
      button.classList.toggle('is-open');
      container.style.maxHeight = outerHeight === 0 ? `${innerHeight}px` : 0;
    }

    window.addEventListener('resize', function() {
      if (window.matchMedia('(min-width: 960px)').matches) {
        container.style.maxHeight = '';
        button.classList.remove('is-open');
      }
    });
  });
  
}());